import "./checkboxCustom.css";
import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import ReactPopover from "react-popover";
import DayPicker from "react-day-picker";
import { dateUtils } from "react-day-picker/utils";
import { localeCustomUtils } from "../lib/LocaleUtilisPl";
import InputCustom from "./inputCustom.react";
import moment from "moment";
import "./dayPickerCustom.css";

let Popover = React.createFactory(ReactPopover);

export default class DayPickerCustom extends Component {
  updateDate = (e, day, modifiers) => {
    const {
      dayPickerCustomProps,
      defaultLocale,
      isDayPickerVisible
    } = this.props;
    dayPickerCustomProps.actions.setEntityField(
      dayPickerCustomProps.feature,
      dayPickerCustomProps.uid,
      dayPickerCustomProps.field,
      moment(day).format("DD.MM.YYYY")
    );
    dayPickerCustomProps.actions.setIsDayPickerVisible(false);
  };

  onInputClick = () => {
    const { dayPickerCustomProps, isDayPickerVisible } = this.props;
    if (dayPickerCustomProps.entity.get("uid") === isDayPickerVisible) {
      dayPickerCustomProps.actions.setIsDayPickerVisible(false);
    } else {
      dayPickerCustomProps.actions.setIsDayPickerVisible(
        dayPickerCustomProps.entity.get("uid")
      );
    }
  };

  hideDatePicker = () => {
    const { dayPickerCustomProps, isDayPickerVisible } = this.props;
    dayPickerCustomProps.actions.setIsDayPickerVisible(false);
  };

  render() {
    const {
      dayPickerCustomProps,
      defaultLocale,
      isDayPickerVisible
    } = this.props;

    const selectedDay = dayPickerCustomProps.entity.getIn(
      dayPickerCustomProps.field
    )
      ? moment(
          dayPickerCustomProps.entity.getIn(dayPickerCustomProps.field),
          "DD.MM.YYYY",
          true
        ).toDate()
      : new Date();

    const modifiers = {
      selected: day => dateUtils.isSameDay(selectedDay, day)
    };

    let popoverProps = {
      isOpen: isDayPickerVisible === dayPickerCustomProps.entity.get("uid"),
      preferPlace: "below",
      refreshIntervalMs: 10,
      className: "date-popover",
      body: [
        <DayPicker
          initialMonth={selectedDay}
          locale={defaultLocale}
          localeUtils={localeCustomUtils}
          enableOutsideDays={true}
          numberOfMonths={1}
          modifiers={modifiers}
          onDayTouchTap={this.updateDate}
        />
      ]
    };

    const dayPicker = Popover(
      popoverProps,
      <InputCustom
        className={
          isDayPickerVisible === dayPickerCustomProps.entity.get("uid") ? (
            "day-picker-input-z-index"
          ) : (
            ""
          )
        }
        {...dayPickerCustomProps}
        onClick={this.onInputClick}
      />
    );
    return (
      <div>
        {isDayPickerVisible === dayPickerCustomProps.entity.get("uid") && (
          <div
            className="day-picker-background"
            onClick={this.hideDatePicker}
          />
        )}
        {dayPicker}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/dayPickerCustom.react.js